export default {
  MOBILE: '@media (max-width: 640px)',
  TABLET: '@media (max-width: 1024px)',
  DESKTOP: '@media (max-width: 1440px)',
  DESKTOP_HD: '@media (min-width: 1440px)',
  RATIO_16_9: '@media (min-aspect-ratio: 16/9)',
  RATIO_16_10: '@media (min-aspect-ratio: 16/10)',
  RATIO_16_11: '@media (max-aspect-ratio: 16/11) and (min-width: 1024px)',
  RATIO_16_12: '@media (min-aspect-ratio: 16/12)',
  LANDSCAPE: '@media (orientation: landscape)',
  PORTRAIT: '@media (orientation: portrait)',
  PORTRAIT_DESKTOP: '@media (orientation: portrait) and (min-width: 1024px)',

  INTRO_1: '@media (min-width: 1224px)',
  INTRO_2: '@media (min-width: 1440px)',
  INTRO_3: '@media (min-width: 1580px)',
  INTRO_4: '@media (min-width: 1680px)',
  INTRO_5: '@media (min-width: 2120px)',
  INTRO_6: '@media (min-width: 2500px)',

  NAV: '@media (max-width: 1064px)',
};



// WEBPACK FOOTER //
// ./src/identity/screenSizes.js